import React, { useState } from 'react'
import { CONFIG } from './config'
import styled from 'styled-components'
import { Waypoint } from 'react-waypoint'
import { String } from 'aws-sdk/clients/acm'

/**
 * Component for Scrollytelling
 *
 * Elements for front layer
 * @prop {React.ReactChild[]} front
 *
 * Function returning background layer element
 * index = current visible front layer element
 * @prop {( index:Number )=> React.ReactChild } background
 *
 * gap between the front layer elements as viewport height
 * @prop { Number } distance
 *
 * space after last front element as viewport height
 * @prop { Number } endSpace
 *
 * @returns { React.Element } React Component
 */

export const Scroller = ({
  front,
  back,
  defaultDistanceTop = CONFIG.default.spacerHeight / 2,
  defaultDistanceBottom = CONFIG.default.spacerHeight / 2,
  className,
}: {
  front: JSX.Element[]
  back: (index: number, id: string) => JSX.Element
  defaultDistanceTop?: number
  defaultDistanceBottom?: number
  className?: string
}) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  return (
    <StyledScroller className={'Scroller ' + className} id='scroller'>
      <div className='back' id='back'>
        {back(
          currentIndex,
          front[currentIndex] && front[currentIndex].props.id
        )}
      </div>
      <div className='front' id='front' style={{ overflowY: 'scroll' }}>
        {front.map((element, i) => {
          let dTop =
            element.props.distanceTop || element.props.distanceTop === 0
              ? element.props.distanceTop
              : defaultDistanceTop || 100

          let dBottom =
            element.props.distanceBottom || element.props.distanceBottom === 0
              ? element.props.distanceBottom
              : defaultDistanceBottom || 100

          return (
            <React.Fragment key={'Front_' + i}>
              <Spacer style={{ minHeight: dTop + 'px' }} />

              <Waypoint
                scrollableAncestor={window}
                onEnter={() => setCurrentIndex(i)}
                // onLeave={(e) => {
                //   if (
                //     e.previousPosition === 'inside' &&
                //     e.currentPosition == 'above'
                //   )
                //     return
                //   let newindex = i + (e.currentPosition === 'below' ? -1 : 1)
                //   setCurrentIndex(newindex > 16 ? 16 : newindex)
                // }}
              >
                <div>{element}</div>
              </Waypoint>
              <Spacer style={{ minHeight: dBottom + 'px' }} />
            </React.Fragment>
          )
        })}
      </div>
    </StyledScroller>
  )
}

const Spacer = styled.div`
  pointer-events: none;
`
const StyledScroller = styled.div`
  position: relative;
  display: block;
  .back {
    z-index: 1;
    position: sticky;
    top: 0;
  }

  .front {
    overflow-x: hidden;
    pointer-events: none;
    position: relative;
    z-index: 20;
    width: 100%;
  }
`
